const getFullDate = () => {
    const date = new Date();
    let dd = date.getDate();
    let mm = date.getMonth() + 1;
    const yyyy = date.getFullYear();
    let hour = date.getHours();
    let min = date.getMinutes();
    let sec = date.getSeconds();
    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    if (hour < 10) hour = '0' + hour;
    if (min < 10) min = '0' + min;
    if (sec < 10) sec = '0' + sec;
    return { dd, mm, yyyy, hour, min, sec };
};
export const ddmmyyyyhhmmss = () => {
    const { dd, mm, yyyy, hour, min, sec } = getFullDate();
    return dd + '/' + mm + '/' + yyyy + ' ' + hour + ':' + min + ':' + sec;
};

const hhmmssFromS = (T) => {
    const sec = parseInt(T, 10);
    const hours = Math.floor(sec / 3600);
    const minutes = Math.floor(sec / 60) % 60;
    const seconds = sec % 60;
    return [hours, minutes, seconds]
        .map((v) => v < 10 ? '0' + v : v)
        .filter((v, i) => v !== '00' || i > 0)
        .join(':');
};

export const hhmmss = (T) => {
    return hhmmssFromS(T);
};
